module.exports = __webpack_public_path__ + "static/media/Cycling.86696bb3.svg";